import React from "react";

function ExclamationCircle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <g fill="#6C757D" clipPath="url(#clip0_3201_10763)">
        <path
          fillRule="evenodd"
          d="M9 16.875a7.875 7.875 0 100-15.75 7.875 7.875 0 000 15.75zM9 18A9 9 0 109 0a9 9 0 000 18z"
          clipRule="evenodd"
        ></path>
        <path d="M7.877 12.375a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0zm.11-6.756a1.018 1.018 0 112.025 0L9.62 9.565a.621.621 0 01-1.238 0l-.394-3.946z"></path>
      </g>
      <defs>
        <clipPath id="clip0_3201_10763">
          <path fill="#fff" d="M0 0H18V18H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ExclamationCircle;
